import resources from '@js/resources'
import BaseApi from '@js/api/base-api.js'

const resource = 'tenantTeamTenantUserSkills';

export default class ApiTenantTeamTenantUserSkill extends BaseApi {
  constructor (tenantTeamId) {
    super();
    this.name = 'ApiTenantTeamTenantUserSkill';
    this.url = resources[resource](this.getTenantDomain(), tenantTeamId);
  }
}
